/**
 * Detecta si estamos en un entorno de pruebas donde no deberíamos indexar
 * @returns {boolean} true si estamos en un entorno de pruebas
 */
export function isTestingEnvironment() {
  if (typeof window === 'undefined') {
    // En el servidor, no podemos acceder a window.location
    return false
  }
  
  const { hostname } = window.location
  
  // Detectar URLs de Vercel (*.vercel.app) o staging
  return hostname.endsWith('.vercel.app') || hostname.includes('staging.swipcar.com')
}

/**
 * Determina si se debe aplicar noindex/nofollow
 * @param {boolean} explicitHide - Si se pasa explícitamente hide=true
 * @returns {boolean} true si se debe aplicar noindex/nofollow
 */
export function shouldHideFromSearch(explicitHide = false) {
  return explicitHide || isTestingEnvironment()
}
